import React from 'react';
import { Container, Row, Col, Label } from 'reactstrap';
import Select from 'react-select';
import { handleResponse } from '../helpers/handleresponse';


export class ScanView extends React.Component {
    state = {
        breakpoints: [
            {
                label: 'Event 1',
                value: 1
            },
            {
                label: 'Event 2',
                value: 2
            },
            {
                label: 'Event 3',
                value: 3
            },
            {
                label: 'Event 4',
                value: 4
            },
        ],
        selectIsOpen: false,
        selectedBreakpoint: null,
        errorMessage: '',
        codeDisplay: [],
        value: '',
        sending: false
    }
    componentDidMount() {
        this.autoFocus();
        this.sendTimer = setInterval(this.sendBuffer, 1000);
        document.addEventListener('click', this.autoFocus);
        /*             document.addEventListener('blur', this.autoFocus);  */
        document.addEventListener('keyup', this.handleScan)

        if (localStorage.getItem('breakpoint')) {
            this.setState({ selectedBreakpoint: JSON.parse(localStorage.getItem('breakpoint')) });
        }
    }
    sendBuffer = () => {
        if (!this.state.sending && localStorage.getItem('codes')) {
            if (navigator.onLine) {
                this.setState({ sending: true }, this.sendCode);
            }
        }
    }
    componentWillUnmount() {
        clearInterval(this.sendTimer);
        this.sendTimer = null;
    }

    autoFocus = () => {
        if (!this.state.selectIsOpen) {
            document.body.focus();
            window.focus();
        }
    }
    addCode = (code) => {
        let codes = localStorage.getItem('codes');
        let codeArr = [];
        if (codes) {
            codeArr = JSON.parse(codes);
        }
        codeArr.push(code);
        localStorage.setItem('codes', JSON.stringify(codeArr));
    }
    getCode = () => {
        let codes = localStorage.getItem('codes');
        if (codes) {
            let codeArr = JSON.parse(codes);
            if (Array.isArray(codeArr) && codeArr.length > 0) {
                let code = codeArr.shift();
                localStorage.setItem('codes', codeArr);
                return code;
            }
            else {
                localStorage.removeItem('codes');
                return null;
            }
        }
    }
    handleScan = (e) => {
        if (!this.state.selectedBreakpoint) return;
        var key = e.which || e.keyCode;
        if (key === 13) { // 13 is enter
            const codeInput = this.state.value;
            this.addCode(codeInput);
            const codeDisplay = this.state.codeDisplay;
            codeDisplay.push(codeInput);
            this.setState({ codeDisplay, value: '' });
        }
        else if (!isNaN(parseInt(e.key))) {
            this.setState({ value: this.state.value + e.key });
        }
        if (this.state.codeDisplay.length > 5)
            this.refs[this.state.codeDisplay.length - 1].scrollIntoView({ block: 'end', behavior: 'smooth' });
    }
    onBreakpointSelect = (option) => {
        this.breakpointsList.blur();
        this.setState({ selectedBreakpoint: option, selectIsOpen: false }, this.autoFocus);
        localStorage.setItem('breakpoint', JSON.stringify(option));
    }
    sendCode = () => {
        let isSending = this.state.sending;
        while (isSending) {
            const code = this.getCode();
            if (!code) {
                isSending = false;
            }
            else {
                const requestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ badgeNo: code, eventId: this.state.selectedBreakpoint.value, exhibitorId: 0 })
                };
                fetch(`./api/checkpoint`, requestOptions)
                    .then(handleResponse)
                    .then(_ => { });
            }

        }
        this.setState({ sending: isSending });
    }

    render() {
        const { breakpoints, selectedBreakpoint, codeDisplay } = this.state;
        return (
            <Container className="center">
                {selectedBreakpoint ? <Row style={{ minHeight: '455px', maxHeight: '455px', overflow: 'hidden', textAlign: 'center', fontSize: '50px', backgroundColor: 'lightseagreen', color: '#fff', margin: '55px 0px' }}>
                    <Col ref={this.scanDisplay}>
                        {codeDisplay.length > 0 ? codeDisplay.map((c, i) => {
                            return <p key={i} ref={i}>{c}</p>
                        }) : null}

                    </Col>
                </Row> : null}
                <Row>
                    <Col>

                        <Label>Välj aktivitet</Label>
                        <Select
                       
                            ref={r => this.breakpointsList = r}
                            onChange={selectedOption => this.onBreakpointSelect(selectedOption)}
                            options={breakpoints}
                            value={selectedBreakpoint}
                            onMenuOpen={() => this.setState({ selectIsOpen: true })}
                        />
                    </Col>
                </Row>
                {/*      <Row>
                    <Col>
                        <Label>Scanna koden</Label>
                        <Input
                            onChange={this.handleChange}
                            onKeyUp={this.handleScan}
                            value={this.state.value}
                            ref={r => this.scanInput = r} id="code-input" autoFocus />
                    </Col>
                </Row> */}
                <Row>
                    <Col>
                        <h3>{this.state.errorMessage}</h3>
                    </Col>
                </Row>
            </Container>

        )
    }

}
